<template lang="pug">
.selectInstallation
  //- Barra de navegación
  van-nav-bar(:title='$t("addUnit.unit.selectGroup")', left-arrow, @click-left='close')

  .main.manageDevices__selectGroup
    van-cell-group
      //- Listado de instalaciones
      van-cell(v-for='(installation, installationKey) in installations', :key='installationKey', :title='installation.name', @click='setInstallation({ installationID: installationKey, name: installation.name })')
        van-icon.van-cell__right-icon.text-brand(v-if='installationKey === installationID', slot='right-icon', name='save')

  //- Botón para añadir una nueva instalación
  .button-bottom-group
    .button-bottom(@click='showManageInstallations') {{ $t("addUnit.unit.addGroup") }}

  //- Modal para añadir una Instalación
  van-popup.van-popup--full(v-model='openManageInstallation', position='right', :overlay='false')
    ManageInstallations(v-if='openManageInstallation', @saveInstallation='setInstallation', @close='hideManageInstallations(true)')
</template>

<script>
import ManageInstallations from '@/components/Units/ManageInstallations.vue';
import { mapGetters } from 'vuex';

export default {
  components: { ManageInstallations },
  props: {
    installationID: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      installations: null,
      openManageInstallation: false,
    };
  },

  computed: {
    ...mapGetters({
      getAdvancedInstallations: 'unitsModule/getAdvancedInstallations',
    }),
  },

  methods: {
    /**
     * Obtiene los datos de las instalaciones almacenados en el Store
     * donde el usuario es del tipo advanced
     */
    getInstallationsData() {
      const installations = this.getAdvancedInstallations();

      if (!Object.keys(installations).length) {
        this.showManageInstallations();
      } else {
        this.installations = installations;
      }
    },

    /**
     * Muestra el modal para editar una instalación
     */
    showManageInstallations() {
      this.openManageInstallation = true;
    },

    /**
     * Oculta el modal para editar una instalación
     */
    hideManageInstallations(close) {
      this.openManageInstallation = false;
      if (close) this.close();
    },

    /**
     * Lanza un evento con la instalación seleccionada
     */
    setInstallation(data) {
      this.hideManageInstallations();
      this.$emit('setInstallation', data);
    },

    /**
     * Cierra el selector de instalaciones
     */
    close() {
      this.$emit('close');
    },
  },

  created() {
    this.getInstallationsData();
  },
};
</script>
